import { Center, Loader } from "@mantine/core";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/auth/AuthContext";

/**
 * Route guard.
 *
 * This is a usability measure, not a security boundary — every API endpoint
 * enforces authorization server-side (ARCHITECTURE.md §6.3). Hiding a route in
 * the client protects nothing on its own.
 */
export function RequireAuth({
  children,
  adminOnly = false,
}: {
  children: React.ReactNode;
  adminOnly?: boolean;
}) {
  const { me, isLoading, isAdmin } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }

  if (!me) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
